import { DefaultOptionType } from "antd/es/select";
import { PaginationResponse } from "../../../types";

export interface IIzvestajiIsporuceneMarkicePayload {
  PeriodId: number | null;
  pib: string | null;
}

export interface OznakaSaKolicinom {
  slovnaOznaka: string | null;
  kolicina: number | null;
  redFlag?: boolean;
}

export interface OznakaSaKolicinomPoRM {
  slovnaOznaka: string | null;
  kolicinaPoRM:
    | {
        robnaMarka: string | null;
        cena: number | null;
        kolicina: number | null;
      }[]
    | null;
}

export interface OznakaSaKolicinomPoPakovanju {
  slovnaOznaka: string | null;
  kolicinaPoPakovanju:
    | {
        ambalaza: string | null;
        kolicina: number | null;
      }[]
    | null;
}

export interface OznakaSaKolicinomPoAmbalazi {
  slovnaOznaka: string | null;
  kolicinaPoAmbalazi:
    | {
        ambalaza: string | null;
        kolicina: number | null;
      }[]
    | null;
}

export interface OznakaSaKolicinomSerijskiBrojevi {
  slovnaOznaka: string | null;
  kolicina: number | null;
  serijskiBrojevi?: string[] | null;
}

export interface Report {
  id: number | null;
  brojIDatumZahteva: string | null;
  slovnaOznakaIKolicinaPreuzetihMarkica: string[] | null;
  oznakaSerijeISerijskiBrojPreuzetihMarkica: string[] | null;
  datumIVremeGenerisanjaIzvestaja: string | null;
}

export interface TobaccoReport extends Report {
  brojNeutrosenihMarkicaPrethodniKvartal: OznakaSaKolicinom[] | null;
  brojIskoriscenihMarkicaIzProizvodnje: OznakaSaKolicinom[] | null;
  brojIskoriscenihMarkicaIzUvoza: OznakaSaKolicinom[] | null;
  nazivRobneMarkeIMpcUvoz: OznakaSaKolicinomPoRM[] | null;
  brojOstecenihVidljivihMarkica: OznakaSaKolicinomSerijskiBrojevi[] | null;
  brojOstecenihNevidljivihMarkica: OznakaSaKolicinom[] | null;
  brojNerazduzenihMarkicaISerijskiBrojNaKraju:
    | OznakaSaKolicinomSerijskiBrojevi[]
    | null;
}

export interface CoffeeReport extends Report {
  brojNeutrosenihMarkicaPrethodniKvartal: OznakaSaKolicinom[] | null;
  brojIskoriscenihMarkicaIzProizvodnje: OznakaSaKolicinom[] | null;
  brojIskoriscenihMarkicaIzUvoza: OznakaSaKolicinom[] | null;
  pakovanjaAmbalaza: OznakaSaKolicinomPoPakovanju[] | null;
  brojOstecenihVidljivihMarkica: OznakaSaKolicinomSerijskiBrojevi[] | null;
  brojOstecenihNevidljivihMarkica: OznakaSaKolicinom[] | null;
  brojNerazduzenihMarkicaISerijskiBrojNaKraju:
    | OznakaSaKolicinomSerijskiBrojevi[]
    | null;
}
export interface AlcoholReport extends Report {
  brojNeutrosenihMarkicaPrethodniKvartal: OznakaSaKolicinom[] | null;
  brojIskoriscenihMarkicaIzProizvodnje: OznakaSaKolicinom[] | null;
  brojIskoriscenihMarkicaIzUvoza: OznakaSaKolicinom[] | null;
  zapreminaAmbalaze: OznakaSaKolicinomPoAmbalazi[] | null;
  brojOstecenihVidljivihMarkica: OznakaSaKolicinomSerijskiBrojevi[] | null;
  brojOstecenihNevidljivihMarkica: OznakaSaKolicinom[] | null;
  brojNerazduzenihMarkicaISerijskiBrojNaKraju:
    | OznakaSaKolicinomSerijskiBrojevi[]
    | null;
}
export interface IIzvestajiIsporuceneMarkiceProps {
  period: Array<{ id: number; naziv: string }>;
  showProcessButton: boolean;
  repeatProcess: boolean;
  tobaccoReport: {
    cigareteReport: Array<TobaccoReport>;
    nesagorevajuciReport: Array<TobaccoReport>;
  };
  coffeeReport: CoffeeReport[];
  alcoholReport: AlcoholReport[];
  hasTobaccoCategory: { hasCigarete: boolean; hasNesagorevajuci: boolean };
  hasCoffeeCategory: boolean;
  hasAlcoholCategory: boolean;
}

export interface PeriodicReportsState {
  PeriodId: number | null;
  period: Array<{ id: number; naziv: string }>;
  showProcessButton: boolean;
  repeatProcess: boolean;
  tobaccoReport: {
    cigareteReport: Array<TobaccoReport>;
    nesagorevajuciReport: Array<TobaccoReport>;
  };
  coffeeReport: CoffeeReport[];
  alcoholReport: AlcoholReport[];
  hasTobaccoCategory: { hasCigarete: boolean; hasNesagorevajuci: boolean };
  hasCoffeeCategory: boolean;
  hasAlcoholCategory: boolean;
}

export type UpdatePeriodicReportsFunction = (
  updatedState: Partial<PeriodicReportsState>
) => void;

export enum ReportType {
  ALCOHOL = "1",
  TOBACCO = "2",
  COFFEE = "3",
}

export enum TobaccoReportType {
  CIGARETE = "1",
  NESAGOREVAJUCI = "2",
}

export interface PeriodicReport {
  id: number;
  period: string;
  periodId: number;
  drustvoNaziv: string;
  drustvoPib: string;
  generisaoSistem: boolean;
}

export interface PeriodicReportListFilterPayload {
  drustvoPIB: string | null;
  periodId: string | null;
  sistemskiGenerisan: boolean | null;
  pageNumber: number | null;
  pageSize: number | null;
}

export interface PeriodicReportListResponse
  extends PaginationResponse<PeriodicReport> {
  periodList: Array<{ id: number; naziv: string }>;
}

export interface PeriodicReportListQueryResponse
  extends PaginationResponse<PeriodicReport> {
  periodList: DefaultOptionType[];
}
